import { BooleanInput, TextInput, required } from "react-admin";
import { Grid } from "@mui/material";

const SaveForm = () => {
  return (
    <Grid
      container
      spacing={2}
    >
      <Grid
        item
        lg={4}
        sm={6}
        xs={12}
      >
        <TextInput
          label="Име на български език"
          source="nameBg"
          validate={required()}
        />
      </Grid>
      <Grid
        item
        lg={4}
        sm={6}
        xs={12}
      >
        <TextInput
          label="Име на английски език"
          source="nameEn"
          validate={required()}
        />
      </Grid>
      <Grid
        item
        xs={12}
      >
        <BooleanInput
          label="Активен курс?"
          source="isActive"
          defaultValue={true}
        />
      </Grid>
    </Grid>
  );
};

export default SaveForm;
